module.exports = __webpack_public_path__ + "img/ellipsis-stroke.95b519ab.svg";